




import { Vue, Component } from 'vue-property-decorator';
import RegisterSearchGrid from '@/components/partner/register/RegisterSearchGrid.vue';

@Component({
  components: {
    RegisterSearchGrid,
  },
})
export default class PartnerRegisterSearch extends Vue {
  private writeDetail(partnerNo) {
    this.$router.push({ name: 'PartnerRegisterSearchDetail', params: { partnerNo } });
  }
}
